module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block login logo",
    attrs: {
      "src": "/static/img/logo-white.png"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), (!_vm.passwordReset) ? _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.newPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notStrong: _vm.passwordScoreValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'password',
      "label": 'New Password:',
      "name": 'newPassword',
      "placeholder": 'Please enter your new password.',
      "messages": {
        required: 'This field is required',
        notStrong: 'Password not strong enough'
      }
    },
    on: {
      "input": _vm.validateConfirm
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.confirmPassword),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        notMatch: _vm.passwordConfirmValidator
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'password',
      "label": 'Confirm Password:',
      "name": 'confirmPassword',
      "placeholder": 'Please confirm your password.',
      "messages": {
        required: 'This field is required',
        notMatch: 'Passwords do not match'
      }
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), (_vm.pinRequired) ? _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.pin),
    attrs: {
      "auto-label": "",
      "custom": {
        minlength: _vm.minlengthValidator(4)
      }
    }
  }, [_c('vue-form-input', {
    attrs: {
      "required": "",
      "formstate": _vm.formstate,
      "type": 'text',
      "label": 'PIN:',
      "name": 'pin',
      "mask": '1111',
      "minlength": '4',
      "placeholder": 'Please enter your 4 digit PIN.',
      "messages": {
        required: 'This field is required',
        minlength: 'PIN must be 4 digits.'
      }
    },
    model: {
      value: (_vm.pin),
      callback: function($$v) {
        _vm.pin = $$v
      },
      expression: "pin"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.formstate.$dirty || _vm.formstate.$invalid || _vm.passwordScoreUpdating
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), (_vm.error) ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Proceed to Login")])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.passwordReset) ? _c('div', {
    staticClass: "content-centered"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("Proceed to Login")])])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Reset Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f7fc18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/ResetPassword.vue
// module id = 1973
// module chunks = 1